import React from 'react';
import "./service.css";
import { DemoCarousel } from '..';
import { servicesList } from './../../list';

function toggleShowcase(e) {
    e.stopPropagation();
    let target = e.nativeEvent.target;
    if (target.classList.contains('show'))
        target = target.parentNode;

    target.parentNode.classList.toggle('active');
}

function Service({ className, title, description, image }) {
    let classes = ['service', className].join(' ');

    return (
        <div className={classes}>
            <h2>{title}</h2>
            <div className={`service-illustration ${image}`}></div>
            <p>{description}</p>
            <div className="showcases" onClick={toggleShowcase}>
                <DemoCarousel className="showcase-demo" list={servicesList[title]} />
                <span className="show" onClick={toggleShowcase}>نشان بده</span>
            </div>
        </div>
    )
}

export default Service;